import React, { useEffect, useState } from 'react';
import { useSocket } from 'utils/hooks/useSocket';
import { formatCurrency } from 'utils';
import Cookies from 'js-cookie';
import { getTournamentRanking } from 'api/tournamentService';
import type { RankingEntry } from 'types/tournament';
import { CASH_TICKER } from 'utils/cash';

import {
  TournamentRank,
  TournamentList,
  NickName,
  Percent,
  Amount,
  TournamentBelt,
  WrappList,
  Rank,
} from './styled';

type Balance = {
  BTC: number;
  USDT: number;
};

type TournamentDetails = {
  data?: {
    id?: number;
    attributes?: {
      name?: string;
      end_at?: string;
      start_at?: string;
      amount_start?: number;
      market_type?: any;
      trade_type?: string;
    };
  };
};

const TournamentRankingList = () => {
  const { tournamentRanking, tournamentDetails } = useSocket() as { tournamentRanking: RankingEntry[], tournamentDetails: TournamentDetails};
  const username = localStorage.getItem('username') ?? Cookies.get('username');
  // TEAM_003: Support both legacy { data: { attributes: { ... } } }
  // and new flattened { data: { ... } } tournamentDetails shapes.
  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData ?? {};
  const tournamentType = attributes?.trade_type;
  // const { totalMoneyString } = useWalletData();
  // const totalUSDT = tournamentType === "Margin" ? tournamentRanking[username] : totalMoneyString;
  const [initialMoney, setInitialMoney] = useState(0);
  const [localTournamentRanking, setLocalTournamentRanking] = useState<RankingEntry[]>([]);

  useEffect(() => {
    const checkTournamentRanking = async () => {
      const localRawData: any = tournamentDetails?.data;
      const localAttributes = localRawData?.attributes ?? localRawData ?? {};
      const tournamentId = localRawData?.id;
      const initial = localAttributes?.amount_start || 1;
      setInitialMoney(initial);

      if ((!Array.isArray(tournamentRanking) || tournamentRanking.length === 0) && tournamentId) {
        try {
          const apiData = await getTournamentRanking(tournamentId);
          setLocalTournamentRanking(apiData);
        } catch (error) {
          console.error('Error fetching tournament ranking:', error);
        }
      } else {
        setLocalTournamentRanking(tournamentRanking);
      }
    };

    checkTournamentRanking();

  }, [tournamentRanking, tournamentDetails?.data?.id, tournamentDetails?.data?.attributes?.amount_start]);

  return (
    <TournamentRank className={tournamentType}>
      <>
        {localTournamentRanking.map((entry, idx) => {
          const totalUSDT = entry.totalInUSDT;
          const player = entry.username;
          const percentageChange = ((totalUSDT - initialMoney) / initialMoney) * 100;
          const isInvalidData = isNaN(totalUSDT) || isNaN(percentageChange);
          const position = entry.rank ?? idx + 1;
          return (
            <TournamentList key={player} className={player === username ? 'is_me' : ''}>
              <Rank>{position}.</Rank>
              <WrappList>
                <TournamentBelt>
                  <NickName>{player}</NickName>
                  {!isInvalidData && (
                    <Percent className={percentageChange > 0 ? 'up_state' : percentageChange < 0 ? 'down_state' : ''}>
                      {percentageChange > 0 ? `+${percentageChange.toFixed(2)}` : percentageChange.toFixed(2)}%
                    </Percent>
                  )}
                </TournamentBelt>
                {!isInvalidData && (
                  <Amount className={`AmountDetails ${totalUSDT > initialMoney ? 'up_state' : totalUSDT < initialMoney ? 'down_state' : ''}`}>
                    {formatCurrency(totalUSDT)} {CASH_TICKER}
                  </Amount>
                )}
              </WrappList>
            </TournamentList>
          );
        })}
      </>
    </TournamentRank>
  );
};

export default TournamentRankingList;
